import icon from "discourse/helpers/d-icon";
import { i18n } from "discourse-i18n";
import CirclesPrivacyStatus from "../privacy-status";

<template>
  <div class="circles-card__badges" ...attributes>
    <CirclesPrivacyStatus
      class="badge badge-notification"
      @model={{@model}}
      @extendedName={{true}}
    />
    {{#if @model.is_circle_owner}}
      <div class="circles-owned-status badge badge-notification">
        {{icon "shield-halved"}}
        {{i18n "discourse_circles.circle.you_are_the_owner"}}
      </div>
    {{/if}}
  </div>
</template>
